import React from "react";
import "./Teaching.css";

export default function Teaching() {
  return (
    <main className="teaching">
      <div className="teaching-inner">
        <h1 className="teaching-title">Teaching</h1>
        <p className="teaching-intro">
          I have taught courses in mathematics, microeconomics, macroeconomics,
          and game theory. My teaching approach emphasizes
          fostering intuition, revealing the interconnections among concepts,
          and supporting students in building both confidence and effective
          problem-solving skills.
        </p>

        <div className="teaching-cards">
          <section className="teaching-card">
            <h2 className="teaching-school">City College of New York</h2>
            <h3 className="teaching-subtitle">Undergraduate courses</h3>
            <ul className="teaching-list">
              <li>
                ECO 10002 – Mathematical Methods for Economics and Business,
                Instructor (Fall 2023 – Present)
              </li>
              <li>
                ECO 10250 – Principles of Microeconomics, TA to G. Frey (Fall
                2025 – Spring 2026)
              </li>
            </ul>
          </section>

          <section className="teaching-card">
            <h2 className="teaching-school">CUNY Graduate Center</h2>
            <h3 className="teaching-subtitle">Graduate courses</h3>
            <ul className="teaching-list">
              <li>Machine Learning, TA to L. Maliar (Fall 2026)</li>
            </ul>
          </section>

          <section className="teaching-card">
            <h2 className="teaching-school">Kyiv School of Economics</h2>
            <h3 className="teaching-subtitle">Graduate courses</h3>
            <ul className="teaching-list">
              <li>Game Theory, TA to K. Sonin (Summer 2024)</li>
              <li>Microeconomics, TA to P. Prokopovych (Spring 2021)</li>
              <li>Microeconomics, TA to E. Besedina (Fall 2021)</li>
            </ul>
            <h3 className="teaching-subtitle">Undergraduate courses</h3>
            <ul className="teaching-list">
              <li>Microeconomics, TA to Y. Kuntsevych (Spring 2022)</li>
              <li>Macroeconomics, TA to Y. Kuntsevych (Spring 2022)</li>
            </ul>
          </section>
        </div>

        <div className="teaching-links">
          <a
            href="https://www.ccny.cuny.edu/profiles/marian-melnyk?srsltid=AfmBOooafU4gyEg4UpeU3puhsPNW6Iymr0MjTsqhh1wvLoBQ5A6YFUtC"
            target="_blank"
            rel="noopener noreferrer"
            className="teaching-link"
          >
            CCNY Profile
          </a>
          <a
            href="https://commons.gc.cuny.edu/members/mmelnyk/blogs/"
            target="_blank"
            rel="noopener noreferrer"
            className="teaching-link"
          >
            CUNY Commons
          </a>
          <a
            href="https://math4econ.commons.gc.cuny.edu/"
            target="_blank"
            rel="noopener noreferrer"
            className="teaching-link"
          >
            Math for Econ
          </a>
        </div>
      </div>
    </main>
  );
}
